import React, { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { Youtube, Instagram } from 'lucide-react';
import TikTokIcon from './icons/TikTokIcon';

const StatsBanner = () => {
  const [youtubeCount, setYoutubeCount] = useState<number | null>(null);
  const [instagramCount, setInstagramCount] = useState<number | null>(null);
  const [tiktokCount, setTiktokCount] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchStats = async () => {
      setLoading(true);
      try {
        const docRef = doc(db, 'socialStats', 'subscriberCounts');
        const docSnap = await getDoc(docRef);
        
        if (docSnap.exists()) {
          const data = docSnap.data();
          setYoutubeCount(data.youtube);
          setInstagramCount(data.instagram);
          setTiktokCount(data.tiktok);
        } else {
          setError("Document de statistiques non trouvé.");
        }
      } catch (err) {
        console.error("Erreur lors de la récupération des statistiques:", err);
        setError("Impossible de charger les statistiques.");
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  const formatCount = (count: number | null): string => {
    if (count === null) return '...';
    if (count >= 1000) {
      return `${Math.floor(count / 1000)}k+`;
    }
    return `${count}+`;
  };

  if (loading) {
    return (
      <section className="bg-[#9a6ebd] py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <div className="animate-spin rounded-full h-8 w-8 border-2 border-white border-t-transparent mx-auto mb-2"></div>
            <p>Chargement des statistiques...</p>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="bg-[#9a6ebd] py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <p>{error}</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="bg-[#9a6ebd] py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8">
          <a
            href="https://www.youtube.com/@comprendrelesses"
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center text-white hover:opacity-90 transition-opacity"
          >
            <Youtube size={32} className="mb-2" />
            <span className="text-2xl font-bold">{formatCount(youtubeCount)}</span>
            <span className="text-white/90">Abonnés Youtube</span>
          </a>

          <a
            href="https://www.instagram.com/comprendre_les_ses"
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center text-white hover:opacity-90 transition-opacity"
          >
            <Instagram size={32} className="mb-2" />
            <span className="text-2xl font-bold">{formatCount(instagramCount)}</span>
            <span className="text-white/90">Abonnés Instagram</span>
          </a>

          <a
            href="https://www.tiktok.com/@comprendre_les_ses"
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center text-white hover:opacity-90 transition-opacity"
          >
            <TikTokIcon size={32} className="mb-2" />
            <span className="text-2xl font-bold">{formatCount(tiktokCount)}</span>
            <span className="text-white/90">Abonnés TikTok</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default StatsBanner;